export const publicURL = process.env.REACT_APP_PUBLIC_S3_BASE_URL;
export const s3BaseURL = (process.env.REACT_APP_S3_BASE_URL ?? '').replace(/\/$/, '');
export const aosphereURL = process.env.REACT_APP_AOSPHERE_URL;
export const apiURL = process.env.REACT_APP_API_BASE_URL;
export const v2ApiURL = process.env.REACT_APP_V2_API_BASE_URL;
export const errorLogsAPIBaseurl = process.env.REACT_APP_API_ERROR_LOGS_URL;
export const coldFusionUrl = process.env.REACT_APP_CF_APP_URL;
export const dataUsageReportUrl = process.env.REACT_APP_CF_DATA_USAGE_REPORT_APP_URL;
export const fileExportURL = process.env.REACT_APP_API_FILE_EXPORT;
export const htmlToExcelURL = process.env.REACT_APP_API_HTML_TO_EXCEL_URL;
export const civic_computing_key = process.env.REACT_APP_CIVIC_COMPUTING_KEY;
export const supportFormURL = process.env.REACT_APP_SUPPORT_FORM_URL;
export const pbSourceFilesURL = process.env.REACT_APP_PB_SOURCE_FILES;
/** LEI search agent config (GQA); override per environment via .env */
export const isLoggedKey = 'isLoggedIn';
export const API_REQUEST_LIMIT = 25;
export const apiMaxRetryCount = Number(process.env.REACT_APP_API_MAX_RETRIES ?? 2);
export const apiRetryBaseDelayMs = Number(process.env.REACT_APP_API_RETRY_BASE_DELAY_MS ?? 500);
export const PB_PRODUCT_ID = 180;
export const DATA_PRIVACY_PRODUCT_ID = 155;
export const API_PRODUCT_RENDER_TYPE_ID = 105;
export const COUNTRY_MANUAL_TYPE_CODE = 'CR';
export const RENDER_STYLE_NAME_2_CODE={"Private Banking":"pb", "Credit":"CR"}
export const ContentTileBehaviourType = {
  Unused: 101,
  EditorialPage: 102,
  Link: 103,
  Product: 104,
  FullProduct: 105,
  Template: 106,
  Pdf: 107,
  Grid: 108,
} as const;
export const ReportType = {
  Single: 'Single',
  Multi: 'Multi',
  Tab: 'Tab',
} as const;
export const AllenOveryID = 101;
export const Tab = 103;
export const MaxCompareLimit = 150;
export const MainDocumentTypeID = "101,107,108,109,110";
export const ROLE_ID_ADMINISTRATOR = 1;
export const ROLE_ID_EDITOR = 2;
export const GRID_CONSTANT = {
  ROW_COL_TEXT_ENTRIES: 101,
  ROW_COL_OTHER_GRID: 102,
  ROW_COL_COUNTRIES: 103,
  ROW_COL_DATEFORMAT: 0,

  CELL_RICHTEXT: 104,
  CELL_PICKLIST: 105,
  CELL_OTHER_GRID: 106,
  CELL_DATE_FORMAT: 107,
  CELL_NUMBERS: 108,
  CELL_FORMAT: 101,

  DEFAULT_STYLE_FORMAT: 100,
  RED_STYLE_FORMAT: 101,
  LIGHTBLUE_STYLE_FORMAT: 102,
  DARKBLUE_STYLE_FORMAT: 103,

  FIRST_COL_SORT_ASCENDING: 101,
  FIRST_COL_SORT_DESCENDING: 102,
  FIRST_COL_SORT_MANUAL: 0,

  ACCEPT_GRID_EXCEL_MIME_TYPES: "application/excel,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

  SYSTEM_PREDEFINED_STYLE_TYPE: 101,
  PICKLIST_STYLE_TYPE: 102,
  ROW_HIGHLIGHT_STYLE_TYPE: 103,
  COLUMN_HIGHLIGHT_STYLE_TYPE: 104,
  TEXT_DECORATION_STYLE_TYPE: 105,
  ALTERNATE_GRID_ROW_STYLE_TYPE: 106,

  COLUMN_SEARCH_NONE: 0,
  COLUMN_SEARCH_TEXT: 101,
  COLUMN_SEARCH_FILTER: 102
};

export const pageTemplateConstant = {
  NoneComplexity: 201,
  MainAnswer: 101,
  TitlewithDescription: 102,
  TextWithColorOption: 103,
  BulletedList: 104,
  AnswerWithComplexity: 105,
  TableTypeAnswer: 106,
  TextWithColorOption_SingleColumn: 107,
  TextOnly: 108,
  FullCKEditor: 109,
  BulletedList_SingleColumn: 110,
  NormalTopicType: 101,
  ExpandableTopicType: 102,
  AccordionTopicType: 103,
  AnswerType_Text: 101,
  AnswerType_ColorOption: 102,
  AnswerType_Complexity: 103,
  AnswerType_Title: 104,
  AnswerType_Description: 105
};

export const MIN_FILE_SIZE = 1024; // 1 KB — rejects empty or corrupt files
export const MIN_FILE_SIZE_ERROR = 'The selected file appears to be empty or invalid (file size is too small). Please upload a valid file.';
export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB
export const FILE_SIZE_ERROR = 'File size exceeds the maximum limit of 30MB. Please select a smaller file.';

export const PREVIOUS_LOCATION_KEY = 'eurl_guard_previous_location';
/** localStorage key for the last PDF viewer zoom the user chose (one browser session user). */
export const PDF_VIEWER_ZOOM_LEVEL_KEY = 'pdfViewerZoomLevel';
import packageJson from '../../package.json';
export const codeVersion = packageJson.version;
export const platFormVersion = '2';
export const loginWithKeycloak = process.env.REACT_APP_LOGIN_WITH_KEYCLOAK;

export const isKeycloakLoginEnabled = (): boolean =>
  process.env.REACT_APP_LOGIN_WITH_KEYCLOAK === 'true';

/** reCAPTCHA Enterprise (Forgot Password and error-email support flows) */

export const REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_SITE_KEY_FOR_FORGOT_PASSWORD =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_SITE_KEY_FOR_FORGOT_PASSWORD ?? '';

export const REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_SITE_KEY_FOR_ERROR_EMAIL =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_SITE_KEY_FOR_ERROR_EMAIL ?? '';

export const isForgotPasswordCaptchaEnabled = process.env.REACT_APP_IS_FORGOT_PASSWORD_CAPTCHA_FLAG;

export const contactUsEmail = 'support@aosphere.com';

export const onlineServicesEmail = "info@aosphere.com";

/** Official aosphere YouTube channel. Same URL in every environment. */
export const aosphereYouTubeURL = 'https://www.youtube.com/@aosphere2898';

export const keycloakClientId = process.env.REACT_APP_CLIENT_ID;
export const keycloakViewerClientId = process.env.REACT_APP_SECOND_CLIENT_ID;
export const keycloakAuthority = process.env.REACT_APP_KEYCLOAK_AUTHORITY;
export const RANGE_CHUNK_SIZE = 512 * 1024; // 524,288 bytes (512 KB)

export const MAX_URL_LENGTH = 2000;
